import {
  Heading,
} from "@/components";
import { Card, CardContent } from "@/components/ui";
import { AlertCircle, CheckCircle2 } from "lucide-react";
import useAuditTrailView from "./useAuditTrailView";
import { sourceSystemOptions } from "../consts";
import moment from "moment";
import { ManualEntry } from "./ManualEntry";
import { capitalize } from "@/lib/utils";

const AuditTrailView = () => {
  const {
    breadcrumbData,
    pageTitle,
    auditTrailData,
    isFailStatus
  } = useAuditTrailView();

  return (
    <div className="p-4 md:p-6 space-y-4">
      <Heading title={pageTitle} breadcrumbData={breadcrumbData} />

      {isFailStatus && (
        <Card className="bg-red-50 border border-pink-700 rounded-[10px]">
          <CardContent className="px-4">
            <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-2">
              <div className="flex items-start gap-2">
                <AlertCircle className="h-6 w-6 text-red-600" />
                <div className="text-red-600 flex flex-col">
                  <span className="text-[17px] font-semibold ">Submission Rejected</span>
                  <div className="text-[12px] flex flex-col">
                    {auditTrailData?.metadata?.errors?.map((err: any) => <span>{capitalize(err?.type || "")}: {err?.errorMessage || ""}</span>)}
                  </div>
                </div>
              </div>
              <div className="text-[12px] text-g-400">
                Entry ID: {auditTrailData?.displayId || ''}
              </div>
            </div>
          </CardContent>
        </Card>
      )}
      
      {auditTrailData ? <Card className="bg-white border border-g-200 rounded-[10px] p-0">
        <CardContent className="px-5 py-4">
          <div className="flex flex-wrap items-center gap-3 border-b border-g-200 pb-4">
            <CheckCircle2 className="h-6 w-6 text-green-600" />
            <span className="text-[20px] font-semibold text-primary">{auditTrailData?.displayId || ""}</span>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-6 gap-4 pt-4">
            <div>
              <div className="text-[12px] text-g-400">Source System</div>
              <div className="text-[13px] font-semibold text-primary">{sourceSystemOptions?.find((item: any) => item.value == auditTrailData?.sourceSystem)?.label || ""}</div>
            </div>
            <div>
              <div className="text-[12px] text-g-400">Document Type</div>
              <div className="text-[13px] font-semibold text-primary">{auditTrailData?.documentType || ""}</div>
            </div>
            <div>
              <div className="text-[12px] text-g-400">Source Reference</div>
              <div className="text-[13px] font-semibold text-primary w-[80%] break-all ">{auditTrailData?.sourceReferenceId || ""}</div>
            </div>
            <div>
              <div className="text-[12px] text-g-400">Submission Time</div>
              <div className="text-[13px] font-semibold text-primary">{auditTrailData?.submissionTimestamp ? moment.utc(auditTrailData?.submissionTimestamp).local().format("MM/DD/YYYY HH:mm:ss") : ""}</div>
            </div>
            <div>
              <div className="text-[12px] text-g-400">Processing Time</div>
              <div className="text-[13px] font-semibold text-primary">{auditTrailData?.totalProcessingTimeMs ? `${auditTrailData?.totalProcessingTimeMs} ms` : ""}</div>
            </div>
            <div>
              <div className="text-[12px] text-g-400">Reference JE ID</div>
              <div className="text-[13px] font-semibold text-primary">{auditTrailData?.referenceJeId || ""}</div>
            </div>
          </div>
        </CardContent>
      </Card> : <></>}

      <ManualEntry />
    </div>
  );
};

export default AuditTrailView;
